export default __webpack_public_path__ + "static/24934220-night-8765b644c565a2dbcc055fe1ba4c6090.webm";